export default __webpack_public_path__ + "assets/img/empty-programs@3x.png";